
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M12.5714 15.8572V10.7143M12.5714 10.7143L10 13.2857M12.5714 10.7143L15.1429 13.2857"></path><path d="M20.2857 12.8571C20.2857 17.3543 16.64 21 12.1429 21C7.64568 21 4 17.3543 4 12.8571C4 10.7344 4.81223 8.80143 6.14286 7.35197C6.86351 6.56697 7.73621 5.92379 8.71429 5.46913C9.75635 4.98472 10.918 4.71429 12.1429 4.71429M12.1429 4.71429L10 7.71429M12.1429 4.71429L9.14286 3"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiUpdate",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
